import gql from 'graphql-tag';

export default gql`
    mutation EditAssetLoad($input: EditAssetLoadInput) {
        editAssetLoad(input: $input) {
            errors
        }
    }
`;
